var map = {
	"./user.js": "pRGc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OIFf";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules/userStore/modules nonrecursive \.js$
// module id = OIFf
// module chunks = 1